/**
 * Central place for the API layer to get the current Clerk session token.
 * The getter is set by the App when Clerk is available (signed-in context).
 */

let tokenGetter: (() => Promise<string | null>) | null = null;

export function setAuthTokenGetter(
  getter: (() => Promise<string | null>) | null,
): void {
  tokenGetter = getter;
}

export async function getAuthToken(): Promise<string | null> {
  if (!tokenGetter) return null;
  return tokenGetter();
}
